import {
  BrandPortalModal,
  Button,
} from "../../../../../components/design-system";
import { COPY } from "../../copy";
import { copyParagraphs, renderCopy } from "../../renderCopy";

type AdTypesModalProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * Reference-only dialog for the two ad types. There is nothing to decide here,
 * so the footer carries a single dismissal rather than a confirm/cancel pair.
 *
 * It lives on the Overview because that is where the ad type filter first
 * appears, and the whole tab — every headline metric, the month table's
 * columns — is cut by these two definitions.
 *
 * Opened from the info button on that filter's menu rather than from the page
 * behind it: the definitions are only load-bearing at the moment someone is
 * choosing between the two.
 */
export function AdTypesModal({ open, onClose }: AdTypesModalProps) {
  return (
    <BrandPortalModal
      open={open}
      onClose={onClose}
      title={COPY.overview.adTypesModal.title}
      footer={
        <div className="flex justify-end">
          <Button variant="primary" size="small" onClick={onClose}>
            {COPY.overview.adTypesModal.confirm}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 pb-2 text-sm leading-5 text-[#333]">
        {copyParagraphs(COPY.overview.adTypesModal.body).map((paragraph) => (
          <p key={paragraph}>{renderCopy(paragraph)}</p>
        ))}
      </div>
    </BrandPortalModal>
  );
}
